import * as service from './service'
import { HTTP_CODE } from '@/utils/request'

export default {
  namespace: 'shansongValueValueDetail',
  state: {
    demoData: {}
  },
  effects: {
    * activeDetail ({ payload }, { call, put }) {
      const res = yield call(service.activeDetail, payload)
      if (res.data.status !== HTTP_CODE.success) {
        throw new Error(res.data.err)
      }
      return res.data
    },
    * getRuleDetail ({ payload }, { call, put }) {
      const res = yield call(service.ruleDetail, payload)
      //   if (res.data.status !== HTTP_CODE.success) {
      //     throw new Error(res.data.err)
      //   }
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
